import { render, staticRenderFns } from "./EduKarierMobileApp.vue?vue&type=template&id=d4ab0b58&scoped=true&"
import script from "./EduKarierMobileApp.vue?vue&type=script&lang=js&"
export * from "./EduKarierMobileApp.vue?vue&type=script&lang=js&"
import style0 from "./EduKarierMobileApp.vue?vue&type=style&index=0&id=d4ab0b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ab0b58",
  null
  
)

export default component.exports